import { Injectable, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class NetworkService {

  private isBrowser: boolean;

  constructor(
    private ngZone: NgZone,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      window.addEventListener('offline', this.handleOffline);
      window.addEventListener('online', this.handleOnline);
    }
  }

  private handleOffline = () => {
    this.ngZone.run(() => {
      this.router.navigate(['/no-internet']);
    });
  };

  private handleOnline = () => {
    this.ngZone.run(() => {
      // تقدر هنا ترجع لآخر route لو حابب
      this.router.navigate(['/']);
    });
  };
}
